//deps
import React, { memo, useCallback, useContext } from "react";

//contexts
import { CartContext } from "@cart-client/contexts/CartContext";
import { AnalyticsContext } from "@swiggy-private/checkout-core";
import { STRESS_COMMS_TEST_IDS } from "@swiggy-private/cart-test-ids";

//styles
import { SlaCommsWrapper } from "./styles";

//helpers
import { getStressComms } from "@cart-client/helpers/StressCommsHelper";
import { isEmpty } from "@swiggy-private/js-utils";
import { impressionCartStressComms } from "@cart-client/analytics/events";

//components
import { SlaComms } from "@swiggy-private/cart-ui";

const StressCommsWrapper = () => {
    const {
        cartState: { localCart, reviewedCart: cartResponse },
    } = useContext(CartContext);

    const { impressionEvent } = useContext(AnalyticsContext);

    const stressComms = getStressComms(localCart);

    const onStressCommsViewEnter = useCallback(
        (isVisible: boolean) => {
            if (isVisible) {
                impressionCartStressComms({
                    cartId: `${cartResponse?.data?.cartId || ""}`,
                    msg: stressComms?.slaText,
                    impressionEvent,
                });
            }
        },
        [cartResponse?.data?.cartId, impressionEvent, stressComms?.slaText],
    );

    if (isEmpty(stressComms?.slaText)) {
        return null;
    }

    return (
        <SlaCommsWrapper data-testid={STRESS_COMMS_TEST_IDS.STRESS_COMMS_WRAPPER}>
            <SlaComms {...stressComms} onCommsVisible={onStressCommsViewEnter} />
        </SlaCommsWrapper>
    );
};

export default memo(StressCommsWrapper);
